<template>
  <div>
    <!-- 上方主体 政府服务-->
    <div
      class="container_top"
      id="topCont"
      @mouseover="barNum = 0"
      v-if="contList.picUrl"
    >
      <!-- 轮播图 -->
      <div class="topTitCont">
        <img
          style="width: 100%; display: block"
          :src="contList.picUrl"
          alt=""
        />
        <div class="cont_topTil">{{ contList.menuName }}</div>
        <div class="cont_topShad">{{ contList.menuNameEn }}</div>
      </div>

      <!-- <div class="tapCont">
      <div class="tapAll">
        <div
          class="tapOne"
          :class="tapFlg == 1 ? 'colr' : ''"
          @click="tapClic(1)"
        >
          服务业务
        </div>
        <div
          class="tapOne"
          :class="tapFlg == 2 ? 'colr' : ''"
          @click="tapClic(2)"
        >
          系统集成服务
        </div>
        <div
          class="tapOne"
          :class="tapFlg == 3 ? 'colr' : ''"
          @click="tapClic(3)"
        >
          安全通讯解决方案
        </div>
        <div
          class="tapOne"
          :class="tapFlg == 4 ? 'colr' : ''"
          @click="tapClic(4)"
        >
          私有通讯解决方案
        </div>
        <div
          class="tapOne"
          :class="tapFlg == 5 ? 'colr' : ''"
          @click="tapClic(5)"
        >
          政府EMM管理系统
        </div>
      </div>
      <div
        :class="tapHomeFlg ? 'tapHome' : tapNum == 1 ? 'tapPackUp' : 'tapPack'"
      >
        <div
          class="tapOne"
          :class="tapFlg == 1 ? 'colr' : ''"
          @click="tapClic(1)"
        >
          服务业务
        </div>
        <div
          class="tapOne"
          :class="tapFlg == 2 ? 'colr' : ''"
          @click="tapClic(2)"
        >
          系统集成服务
        </div>
        <div
          class="tapOne"
          :class="tapFlg == 3 ? 'colr' : ''"
          @click="tapClic(3)"
        >
          安全通讯解决方案
        </div>
        <div
          class="tapOne"
          :class="tapFlg == 4 ? 'colr' : ''"
          @click="tapClic(4)"
        >
          私有通讯解决方案
        </div>
        <div
          class="tapOne"
          :class="tapFlg == 5 ? 'colr' : ''"
          @click="tapClic(5)"
        >
          政府EMM管理系统
        </div>
      </div>
    </div> -->

      <!-- 服务业务 -->
      <div
        class="publicCloud"
        ref="publom"
        id="publicCloud"
        v-if="contList.menuModule && contList.menuModule.length > 0"
      >
        <div class="publ_compe_tit">{{ contList.menuModule[0].title }}</div>
        <div class="publ_compe_fy">
          {{ contList.menuModule[0].content }}
        </div>
        <!-- <div class="publ_compe_txt">
        Ao0haMnd
        藏力开放平台是网愿科技团队开发的基于深度学习的新一代人工智能平台平台集成了NIP、
        机器视贷和和识图诸等A关技术、备全A模型生产定营能力，内蛋通信行业、
        汽车制造业等多种模型配蛋藏单、使用便捷、性能优异、GPU资源共享效率高，
        支持低代码开发，助力企业加速数智化转型进程。
      </div> -->

        <div class="publCont">
          <div
            class="publ_img"
            v-for="(item, index) in contList.menuModule[0].detailsList"
            :key="index"
            @click="goGoveService(item)"
          >
            <div class="img_Cont">
              <img :src="item.imgUrl" alt="" />
              <div class="img_Cont_Tit">{{ item.title }}</div>
              <div class="knowMore">
                了解更多<i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <!-- <div class="publ_Tit">优势标题文案内容</div>
            <div class="publ_Txt">
              京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
            </div> -->
          </div>
        </div>
      </div>

      <!-- 系统集成服务 -->
      <!-- <div class="privateComm" id="privateComm">
      <div class="priv_compe_tit">系统集成服务</div>
      <div class="priv_compe_fy">
        致力于成为行业用户场景物联与人工智能应用的数字化转型合作伙伴
      </div>
      <div class="privateCont">
        <div class="privLeft">
          <img src="@/assets/enterprise/Slice105.png" alt="" />
          <div class="privLeft_tit">私有服务</div>
        </div>
        <div class="privRight">
          <div class="privRight_top">
            <img src="@/assets/enterprise/Slice106.png" alt="" />
            <div class="privRight_tit">基础设施即服务</div>
          </div>
          <div class="privRight_bot">
            <img src="@/assets/enterprise/Slice107.png" alt="" />
            <div class="privBotleft_tit">平台服务</div>
            <img src="@/assets/enterprise/Slice108.png" alt="" />
            <div class="privBotright_tit">服务解决方案</div>
          </div>
        </div>
      </div>
    </div> -->

      <!-- 安全通讯解决方案 -->
      <!-- <div class="publicCloud" id="groupComm">
      <div class="publ_compe_tit">安全通讯解决方案</div>

      <div class="publCont">
        <div class="publ_img">
          <img src="@/assets/enterprise/Slice109.png" alt="" />
          <div>集团服务解决方案</div>
        </div>
        <div class="publ_img">
          <img src="@/assets/enterprise/Slice110.png" alt="" />
          <div>集团服务解决方案</div>
        </div>
      </div>
    </div> -->

      <!-- 私有通讯解决方案 -->
      <!-- <div class="publicCloud" id="enterpriseMob">
      <div class="publ_compe_tit">私有通讯解决方案</div>
      <div class="ente_compe_fy">
        秉承“科技赋能，护佑安全”的理念，致力于自主可控关键核心技术研发为己任,着眼
        新一代网络信息基础设施及重要信息系统安全保障为使命，面向智慧型生产与生活提供全方位的网络与信息安全服务。
      </div>

      <div class="publCont">
        <div class="publ_img">
          <img src="@/assets/enterprise/Slice111.png" alt="" />
          <div>企业办公安全</div>
        </div>
        <div class="publ_img">
          <img src="@/assets/enterprise/Slice112.png" alt="" />
          <div>服务解决方案</div>
        </div>
        <div class="publ_img">
          <img src="@/assets/enterprise/Slice113.png" alt="" />
          <div>服务解决方案</div>
        </div>
      </div>
    </div> -->

      <!-- 政府EMM管理系统 -->
      <!-- <div class="publicCloud" id="gaveEMM">
      <div class="publ_compe_tit">政府EMM管理系统</div>
      <div class="publCont">
        <div class="EMM_img">
          <img src="@/assets/enterprise/SliceGave111.png" alt="" />
          <div>基础设施即服务</div>
        </div>
        <div class="EMM_img">
          <img src="@/assets/enterprise/SliceGave112.png" alt="" />
          <div>平台即服务</div>
        </div>
        <div class="EMM_img">
          <img src="@/assets/enterprise/SliceGave113.png" alt="" />
          <div>基础服务</div>
        </div>
      </div>
    </div> -->
    </div>
    <div id="mobile">
      <goveHome :contList="contList" />
    </div>
  </div>
</template>

<script>
import goveHome from '@/views/mobile/governService/goveHome.vue'
import { getCategoryInfo } from '@/api/index'
export default {
  props: { switchNum: String },
  components: { goveHome },
  data() {
    return {
      swiperOption: {
        loop: true,
        // centeredSlides: true,
        slidesPerView: 1,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          paginationClickable: true
        }
      },
      tapHomeFlg: false,
      tapNum: 0,
      tapFlg: '0',
      contList: {},
      goveList: [
        {
          tit: '硬件定制服务方案',
          url: 'goveHome/governmentalService',
          img:
            'https://oss.jingshucloud.com/gw-bucket/ad75a843-2c46-4175-8c22-8662d9c5dcde.png',
          idNum: '3-1'
        },
        {
          tit: '软件定制服务方案',
          url: 'goveHome/goveSoftware',
          img:
            'https://oss.jingshucloud.com/gw-bucket/3f04ad8a-735f-4bd2-8edb-59365658e6c0.png',
          idNum: '3-2'
        },
        {
          tit: '系统集成服务方案',
          url: 'goveHome/goveSI',
          img:
            'https://oss.jingshucloud.com/gw-bucket/54d6a109-be8c-4a6c-b86d-d19e87ced471.png',
          idNum: '3-3'
        },
        {
          tit: '安全通讯解决方案',
          url: 'goveHome/goveCommunication',
          img:
            'https://oss.jingshucloud.com/gw-bucket/ad75a843-2c46-4175-8c22-8662d9c5dcde.png',
          idNum: '3-4'
        },
        {
          tit: '私有通讯解决方案',
          url: 'goveHome/govePrivateComm',
          img:
            'https://oss.jingshucloud.com/gw-bucket/3f04ad8a-735f-4bd2-8edb-59365658e6c0.png',
          idNum: '3-5'
        },
        {
          tit: '政府EMM管理系统',
          url: 'goveHome/goveEmm',
          img:
            'https://oss.jingshucloud.com/gw-bucket/54d6a109-be8c-4a6c-b86d-d19e87ced471.png',
          idNum: '3-6'
        }
      ]
    }
  },
  computed: {},
  watch: {
    switchNum(curVal, oldVal) {
      // console.log("测试switchNum",curVal, oldVal);

      if (curVal == 3) {
        document
          .getElementById('topCont')
          .scrollIntoView({ behavior: 'smooth' })
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  activated() {
    console.log(this.switchNum)
  },
  created() {
    if (this.switchNum == 3) {
      document.getElementById('topCont').scrollIntoView({ behavior: 'smooth' })
    }
    if (this.$route.params.id) {
      localStorage.setItem('menuId', this.$route.params.id)
    }

    if (this.getID(this.$route.name, this.$store.state.treeList)) {
      localStorage.setItem(
        'menuId',
        this.getID(this.$route.name, this.$store.state.treeList).id
      )
    }
    this.flgId = localStorage.getItem('menuId')
    console.log(localStorage.getItem('menuId'))
    if (this.flgId) {
      this.contList = {
        menuNameEn: ' Government Service',
        picUrl:
          'https://oss.jingshucloud.com/gw-bucket/f276b341-7b43-4884-b9d4-c553af26686f.jpg',
        menuModule: [
          {
            createBy: null,
            createTime: '2023-11-28 15:48:31',
            updateBy: null,
            updateTime: '2023-11-30 16:06:27',
            remark: null,
            id: 5,
            menuId: 22,
            menuName: '政务服务',
            contentType: null,
            title: '服务业务',
            titleEn: null,
            imgUrl: null,
            externalUrl: null,
            contentTitle: null,
            content:
              '面向政府和政企用户提供“感知+数据+认知”的城市级整体解决方案，赋能公共服务',
            routingPath: null,
            idNum: null,
            sortOrder: 0,
            detailsList: [
              {
                createBy: null,
                createTime: null,
                updateBy: null,
                updateTime: '2024-07-18 18:50:48',
                remark: null,
                id: 9,
                menuId: null,
                menuName: null,
                contentType: '5',
                title: '非制式安全终端定制',
                titleEn: null,
                imgUrl:
                  'https://oss.jingshucloud.com/gw-bucket/92a29d5d-ca8e-41c3-a0c8-dfaf55febfd4.jpg',
                externalUrl: null,
                contentTitle: null,
                content: null,
                routingPath: '/static/detail/nonStandardSecurityTerminalCustom',
                imgContent: null,
                idNum: '3-1',
                detailsId: 23,
                sortOrder: 0,
                tableName: 'jingshu_menu_details'
              },
              {
                createBy: null,
                createTime: null,
                updateBy: null,
                updateTime: '2024-07-18 18:50:56',
                remark: null,
                id: 10,
                menuId: null,
                menuName: null,
                contentType: '5',
                title: '专业安全软件定制',
                titleEn: null,
                imgUrl:
                  'https://oss.jingshucloud.com/gw-bucket/fa37f1a9-afeb-4aa3-8e9a-00d73802910d.jpg',
                externalUrl: null,
                contentTitle: null,
                content: null,
                routingPath: '/static/detail/professionalSecuritySoftware',
                imgContent: null,
                idNum: '3-2',
                detailsId: 24,
                sortOrder: 0,
                tableName: 'jingshu_menu_details'
              },
              {
                createBy: null,
                createTime: null,
                updateBy: null,
                updateTime: '2024-07-18 18:51:06',
                remark: null,
                id: 11,
                menuId: null,
                menuName: null,
                contentType: '5',
                title: '系统集成与系统统一化定制',
                titleEn: null,
                imgUrl:
                  'https://oss.jingshucloud.com/gw-bucket/0fb2db79-b4e9-421c-ab0e-825e7ac29d26.jpg',
                externalUrl: null,
                contentTitle: null,
                content: null,
                routingPath: '/static/detail/systemCustom',
                imgContent: null,
                idNum: '3-3',
                detailsId: 25,
                sortOrder: 0,
                tableName: 'jingshu_menu_details'
              },
              {
                createBy: null,
                createTime: null,
                updateBy: null,
                updateTime: '2024-07-18 18:51:26',
                remark: null,
                id: 12,
                menuId: null,
                menuName: null,
                contentType: '5',
                title: '私有集团安全通讯解决方案',
                titleEn: null,
                imgUrl:
                  'https://oss.jingshucloud.com/gw-bucket/ee9a151b-c860-4d0a-9574-ee3f56a35fc1.jpg',
                externalUrl: null,
                contentTitle: null,
                content: null,
                routingPath: '/static/detail/privateSafe',
                imgContent: null,
                idNum: '3-4',
                detailsId: 26,
                sortOrder: 0,
                tableName: 'jingshu_menu_details'
              },
              {
                createBy: null,
                createTime: null,
                updateBy: null,
                updateTime: '2024-07-18 18:52:27',
                remark: null,
                id: 13,
                menuId: null,
                menuName: null,
                contentType: '5',
                title: '移动政务解决方案',
                titleEn: null,
                imgUrl:
                  'https://oss.jingshucloud.com/gw-bucket/fd3a2bd4-9bcf-4afc-b1ab-3e543163697e.jpg',
                externalUrl: null,
                contentTitle: null,
                content: null,
                routingPath: '/static/detail/mobileGovernmentSolution',
                imgContent: null,
                idNum: '3-5',
                detailsId: 27,
                sortOrder: 0,
                tableName: 'jingshu_menu_details'
              },
              {
                createBy: null,
                createTime: null,
                updateBy: null,
                updateTime: '2024-07-18 18:52:37',
                remark: null,
                id: 14,
                menuId: null,
                menuName: null,
                contentType: '5',
                title: '政务EMM管理',
                titleEn: null,
                imgUrl:
                  'https://oss.jingshucloud.com/gw-bucket/0692ef8a-fc3f-45b1-ba09-d8a603c25370.jpg',
                externalUrl: null,
                contentTitle: null,
                content: null,
                routingPath: '/static/detail/goveEMM',
                imgContent: null,
                idNum: '3-6',
                detailsId: 28,
                sortOrder: 0,
                tableName: 'jingshu_menu_details'
              }
            ]
          }
        ],
        routingPath: 'goveHome',
        menuId: 22,
        menuName: '政务服务'
      }
      // getCategoryInfo(this.flgId).then((res) => {
      //   this.contList = res.data.data;
      // });
    }
  },
  methods: {
    // 回调函数
    getID(name, list) {
      let _this = this
      for (let item of list || []) {
        if (item.routingPath == name) return item
        const sum = _this.getID(name, item.children)
        if (sum) return sum
      }
    },
    tapClic(row) {
      this.tapFlg = row
      if (row == 0) {
        document
          .getElementById('publicCloud')
          .scrollIntoView({ behavior: 'smooth' })
      }
      if (row == 1) {
        document
          .getElementById('privateComm')
          .scrollIntoView({ behavior: 'smooth' })
      }
      if (row == 2) {
        document
          .getElementById('groupComm')
          .scrollIntoView({ behavior: 'smooth' })
      }
      if (row == 3) {
        document
          .getElementById('enterpriseMob')
          .scrollIntoView({ behavior: 'smooth' })
      }
      if (row == 4) {
        document
          .getElementById('gaveEMM')
          .scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll() {
      if (this.$refs.publom && this.$refs.publom.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.publom.offsetTop,
        //   this.switchNum
        // );
        if (window.scrollY > 650) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop
          var scroll = scrollTop - this.i
          this.i = scrollTop
          if (scroll < 0) {
            this.tapHomeFlg = false
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true
            this.tapNum = 1
          }
        } else {
          this.tapHomeFlg = false
        }
        this.$emit('switchflg', '0')
      }
    },
    goGoveService(row) {
      this.$router.push({
        name: row.routingPath,
        params: { id: row.id }
      })
      this.$store.commit('changeTabCheck', {
        idNum: row.idNum,
        sumName: ''
      })
      this.$store.state.enterp_somFlg = ''
    }
  }
}
</script>

<style lang="less" scoped>
.container_top {
  width: 100%;
  .topTitCont {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .cont_topTil {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: absolute;
    bottom: 50%;
    //left: 13%;
    font-size: 46px;
    font-weight: 600;
    color: white;
  }
  .cont_topShad {
    opacity: 0.8;
    position: absolute;
    bottom: 45%;
    //left: 13%;
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    font-size: 22px;
    color: white;
  }
}

// 头部tap
.tapCont {
  position: relative;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .tapAll {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tapOne {
    cursor: pointer;
    font-size: 20px;
    margin: 20px;
  }
  .colr {
    // background: linear-gradient(360deg, #003365 0%, #048799 100%);
    position: relative;
    color: #048799;
  }
  .colr::before {
    content: '';
    height: 3px;
    background: #048799;
    position: absolute;
    top: 44px;
    width: 100%;
  }
  @keyframes arise {
    0% {
      top: -80px;
    }
    100% {
      top: 0px;
    }
  }
  .tapHome {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 103px;
    animation: arise 0.5s ease-out;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  .tapPackUp {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
    animation: packUp 0.5s ease-out;
  }
  @keyframes packUp {
    0% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: 0px;
    }
    100% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: -80px;
    }
  }
  .tapPack {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
  }
}

// 硬件定制服务
.publicCloud {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 100px;
  .publ_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }

  .publ_compe_fy {
    font-size: 20px;
    margin-top: 40px;
  }
  .publ_compe_txt {
    width: 80%;
    margin-top: 50px;
    // text-align: center;
  }
  .publCont {
    display: flex;
    // justify-content: center;
    align-items: center;
    // margin: 80px;
    // width: 87%;

    width: 100%;
    max-width: 1230px;
    margin: 0 auto;
    margin-top: 60px;
    flex-wrap: wrap;
  }
  .publ_img {
    margin: 0 15px;
    position: relative;
    width: 380px;
    cursor: pointer;
    overflow: hidden;
    // height: 270px;
    margin-bottom: 30px;
    // width: 31%;
  }
  .publ_img img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: ease all 0.3s;
  }
  .publ_img:hover img {
    transform: scale(1.1);
  }
  // .publ_img div {
  //   margin-top: 20px;
  // }
  .publ_img::before {
    content: '';
    display: block;
    position: absolute; /* 设置绝对定位 */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1;
  }
  .publ_img:hover::before {
    // background-color: rgba(0, 0, 0, 0.4) !important;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.7) 100%
    );
  }
  .publ_img:hover .knowMore {
    // bottom: 10px !important;
    // display: block;
    height: 40px;
    opacity: 1;
    // display: flex;
    // justify-content: center;
    // align-content: center;
  }
  .knowMore {
    position: absolute;
    height: 0;
    // bottom: 40px;
    color: #fff;
    font-size: 16px;
    margin-left: 20px;
    transition: all 0.3s ease-in-out;
    // bottom: -65px !important;
    bottom: 0px !important;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }
  .img_Cont {
    position: relative;

    // overflow: hidden;
    // height: 325px;
  }
  .img_Cont_Tit {
    position: absolute;
    bottom: 20px;
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    z-index: 2;
    transition: all 0.3s ease-in-out;
  }
  .publ_img:hover .img_Cont_Tit {
    bottom: 45px !important;
    // display: flex;
    // justify-content: center;
    // align-content: center;
  }
  .publ_Tit {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-top: 20px;
  }
  .publ_Txt {
    text-align: justify;
  }
}

// 系统集成服务
.privateComm {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px 26px;
  .priv_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }

  .priv_compe_fy {
    font-size: 20px;
    margin: 40px 0;
  }
  .privateCont {
    display: flex;
    margin: 80px;
    justify-content: center;
    align-items: self-start;
  }
  .privateCont img {
    width: 100%;
  }
  .privLeft {
    position: relative;
    margin-right: 30px;
    // height: 450px;
  }
  .privLeft_tit {
    position: absolute;
    bottom: 40px;
    left: 40px;
    font-size: 20px;
    color: #fff;
  }
  .privRight {
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    // align-items: self-end;
  }
  .privRight_top {
    position: relative;
    // height: 250px;
  }
  .privRight_cont img {
    margin-bottom: 37px;
  }
  .privRight_tit {
    position: absolute;
    top: 77%;
    left: 40px;
    font-size: 20px;
    color: #fff;
  }

  .privRight_bot {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-top: 2.9%;
  }
  .privRight_bot img {
    width: 48%;
  }
  .privBotleft_tit {
    position: absolute;
    bottom: 30px;
    left: 40px;
    font-size: 20px;
    color: #fff;
  }
  .privBotright_tit {
    position: absolute;
    bottom: 30px;
    right: 32%;
    font-size: 20px;
    color: #fff;
  }
}
//私有通讯解决方案
.ente_compe_fy {
  font-size: 20px;
  margin: 40px 0;
  width: 65%;
  text-align: center;
}

// 政府EMM管理系统

.EMM_img {
  margin: 0 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.EMM_img div {
  color: #151a23;
  font-size: 23px;
  margin-top: 25px;
}
.EMM_img img {
  width: 100%;
}
</style>
<style lang="scss" scoped>
@import '@/assets/variables.scss';
@media (max-width: $ipad-max-size) {
  #topCont {
    display: none;
  }
  #mobile {
    display: block !important;
  }
}
#mobile {
  display: none;
}
</style>
